// extracted by mini-css-extract-plugin
export default {"loyality":"Loyality_loyality__noUb0"};